const theme = {
  mainColor: "rgb(107, 61, 107)",
  shadeColor: "",
  darkCanvas: "#191919FF",
  mainCanvas: "#282828FF",
  shadeCanvas: "#3D3D3DFF",
  textDark: "#222222FF",
  textLight: "#b2b6bdFF",
  mainFont: "'Merriweather', 'roboto', sans-serif",
  secondaryFont: "'Montserrat', 'roboto', sans-serif",
  whiteOpacity: "rgba(200, 200, 200, 0.25)",
  codeBlockBackground: "#272822",
  transition: "cubic-bezier(0.45, 0.05, 0.55, 0.95)",
};

theme.mainBackground = theme.darkCanvas;
theme.textMain = theme.textLight;

export default theme;
